import { useIntl } from 'react-intl';

import { Card } from '@developer/features';
import {
  pcMonitorPurple,
  pcMonitorPink,
  pcMonitorGreen,
} from '@marketplace/ui-elements';

import classes from './cards.module.scss';

export const Cards = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={classes.cards_wrapper}>
      <Card
        title={formatMessage({
          id: 'developer_main_page_card_title_first',
        })}
        description={formatMessage({
          id: 'developer_main_page_card_text_first',
        })}
        color="pink"
        icon={pcMonitorPink}
      />
      <Card
        title={formatMessage({
          id: 'developer_main_page_card_title_second',
        })}
        description={formatMessage({
          id: 'developer_main_page_card_text_second',
        })}
        color="green"
        icon={pcMonitorGreen}
      />
      <Card
        title={formatMessage({
          id: 'developer_main_page_card_title_third',
        })}
        description={formatMessage({
          id: 'developer_main_page_card_text_third',
        })}
        color="purple"
        icon={pcMonitorPurple}
      />
    </div>
  );
};
